import { Box, Flex, Icon, Tooltip, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { BiCopyAlt, BiCheckDouble } from 'react-icons/bi';

import Loader from 'components/Loader';
import toaster from 'utils/toaster';

interface ICopyClipboard {
  label?: string;
  copyValue: string;
  isLoading?: boolean;
  toolTipDesc?: string;
}

const CopyClipboard: React.FC<ICopyClipboard> = ({ label, copyValue, isLoading = false, toolTipDesc }) => {
  const [copied, setCopied] = useState<boolean>(false);

  const copyToClipboard = () => {
    setCopied(true);
    navigator.clipboard.writeText(copyValue);
    toaster.success({ description: 'Copied successfully!' });
  };

  if (isLoading) return <Loader height="auto" showText={false} spinnerProps={{ size: 'sm', color: 'primary.500' }} />;

  return (
    <Flex alignItems="center" gridGap="2">
      <Text color="primary.500" fontWeight="semibold">
        {label}
      </Text>
      <Tooltip label={toolTipDesc} bg="primary.500">
        <Flex
          bg="primary.100"
          onClick={copyToClipboard}
          cursor="pointer"
          alignItems="center"
          p="1"
          pr="3"
          borderRadius="md"
          border="solid 1px"
          borderColor="primary.500"
          maxW="fit-content"
        >
          <Box borderRight="solid 1.5px" borderColor="primary.500" px="2" mr="2">
            <Icon as={copied ? BiCheckDouble : BiCopyAlt} color="primary.500" h="25px" w="25px" />
          </Box>
          <Box color="primary.500" fontWeight="bold">
            {copyValue}
          </Box>
        </Flex>
      </Tooltip>
    </Flex>
  );
};

export default CopyClipboard;
